import { lazy } from 'react';

/**
 * Lazy loaded instance of the actual SearchDetailsList component.
 *
 * This will trigger the surrounding Suspense while it asynchronously
 * loads the component.
 */
export const LazySearchDetailsList = lazy(async () => {
  await new Promise(r => setTimeout(() => r(undefined), 35));
  return import('./SearchDetailsList/searchList').then(m => ({
    default: m.SearchList,
  }));
});
